export const LOGIN_PAGE_BASE_PATH = '/login';
